import { render, staticRenderFns } from "./AddLanguage.vue?vue&type=template&id=5d00852e&scoped=true&"
import script from "./AddLanguage.vue?vue&type=script&lang=js&"
export * from "./AddLanguage.vue?vue&type=script&lang=js&"
import style0 from "./AddLanguage.vue?vue&type=style&index=0&id=5d00852e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d00852e",
  null
  
)

export default component.exports